import { Link } from 'react-router-dom';
import { useRobotsMeta } from '@/hooks/useRobotsMeta';
import { KokeMascot } from '@/components/common/KokeMascot';

export default function NotFound() {
  useRobotsMeta('noindex,nofollow');

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-text-50 px-4 text-center">
      <KokeMascot mood="lost" size="lg" className="mb-4" />
      <h1 className="text-5xl sm:text-6xl font-bold text-primary-600 mb-2">404</h1>
      <h2 className="text-xl sm:text-2xl font-semibold text-text-800 mb-2">ページが見つかりません</h2>
      <p className="text-text-600 mb-6">お探しのページは存在しないか、移動した可能性があります。</p>
      <Link
        to="/"
        className="px-6 py-3 bg-primary-600 text-white rounded-lg font-semibold hover:bg-primary-700 transition-colors"
      >
        ホームに戻る
      </Link>
    </div>
  );
}
